import React, { useMemo, useRef, useCallback, useEffect, useImperativeHandle, useState, forwardRef } from 'react';
import { Animated, StyleSheet, StatusBar } from 'react-native';
import LinearGradient from 'utils/packages/linearGradient';
import Confetti from 'utils/packages/confetti';
import Button from 'design-system/Button';
import Text from 'design-system/Text';
import Spacer from 'design-system/Spacer';
import Logo from 'design-system/Logo';
import Modal from 'utils/packages/Modal';
import { rem } from 'design-system/values';
import { useMarginBottom } from 'hooks/useMarginBottom';
import { waitlistGradient } from '../colors';
import { formatAmount } from '../utils';
const strings = {
    buttonTitle: 'Thanks, let’s go back',
};
const FreeShareView = forwardRef((_props, ref) => {
    const [state, setState] = useState();
    useImperativeHandle(ref, () => ({
        setState,
    }));
    const confetti = useRef(null);
    const rocketAnimation = useRef(new Animated.Value(0));
    const buttonOpacity = useRef(new Animated.Value(0));
    const logoScale = useRef(new Animated.Value(0));
    const nameOpacity = useRef(new Animated.Value(0));
    useEffect(() => {
        if (state) {
            Animated.sequence([
                Animated.spring(logoScale.current, {
                    toValue: 1,
                    velocity: 0.09,
                    bounciness: 5,
                    speed: 0.15,
                    useNativeDriver: true,
                }),
                Animated.timing(nameOpacity.current, {
                    toValue: 1,
                    duration: 500,
                    useNativeDriver: true,
                }),
                Animated.timing(buttonOpacity.current, {
                    toValue: 1,
                    duration: 400,
                    useNativeDriver: true,
                }),
            ]).start();
        }
        else {
            confetti.current?.startConfetti();
            Animated.timing(rocketAnimation.current, {
                toValue: 1,
                duration: 3000,
                useNativeDriver: true,
            }).start();
        }
    }, [state]);
    const onClose = useCallback(() => {
        Modal.hide();
    }, []);
    const moon = useMemo(() => (<Animated.Image style={[
            styles.moon,
            {
                transform: [
                    {
                        translateY: rocketAnimation.current.interpolate({
                            inputRange: [0, 1],
                            outputRange: [rem(0), rem(20)],
                        }),
                    },
                    {
                        translateX: rocketAnimation.current.interpolate({
                            inputRange: [0, 1],
                            outputRange: [rem(60), rem(40)],
                        }),
                    },
                    { rotate: rocketAnimation.current.interpolate({ inputRange: [0, 1], outputRange: ['18deg', '0deg'] }) },
                ],
            },
        ]} source={require('../img/moon.png')} resizeMode="contain"/>), []);
    const bottom = useMarginBottom('bottom', undefined, styles.button);
    const button = useMemo(() => (<Animated.View style={[bottom, { opacity: buttonOpacity.current }]}>
        <Button brand title={strings.buttonTitle} onPress={onClose}/>
      </Animated.View>), [bottom, onClose]);
    const stars2 = useMemo(() => (<Animated.Image style={[
            styles.clouds,
            {
                transform: [
                    {
                        translateY: rocketAnimation.current.interpolate({
                            inputRange: [0, 1],
                            outputRange: [rem(0), rem(10)],
                        }),
                    },
                ],
            },
        ]} source={require('../img/stars-2.png')}/>), []);
    const stars3 = useMemo(() => (<Animated.Image style={[
            styles.clouds,
            {
                transform: [
                    {
                        translateY: rocketAnimation.current.interpolate({
                            inputRange: [0, 1],
                            outputRange: [rem(0), rem(30)],
                        }),
                    },
                ],
            },
        ]} source={require('../img/stars-3.png')}/>), []);
    return (<LinearGradient {...waitlistGradient} style={styles.container}>
      <StatusBar barStyle="light-content" animated/>
      {stars2}
      {stars3}
      {moon}
      {button}
      <Animated.View style={{ transform: [{ scale: logoScale.current }] }}>
        <Logo S64 uri={state?.logoUrl}/>
      </Animated.View>
      <Spacer h={8}/>
      <Animated.View style={{ opacity: nameOpacity.current }}>
        <Text Text-32 White centered>
          {state?.name}
        </Text>
        <Spacer h={8}/>
        {state ? (<Text TextThin-16 White centered>{`You have just claimed\n${formatAmount(state.amount, 0)} worth of ${state.name}!`}</Text>) : null}
      </Animated.View>
      <Confetti ref={confetti} confettiCount={20}/>
    </LinearGradient>);
});
const styles = StyleSheet.create({
    container: {
        flex: 1,
        padding: rem(24),
        alignItems: 'center',
        justifyContent: 'center',
    },
    moon: { position: 'absolute', top: 0, right: 0 },
    clouds: { position: 'absolute', top: 0 },
    button: {
        position: 'absolute',
        left: rem(16),
        right: rem(16),
    },
});
export default FreeShareView;
